// context/MovieContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { getNowPlayingMovies, getUpcomingMovies, getImageUrl } from '../services/tmdbApi';

const MovieContext = createContext();

export const useMovies = () => useContext(MovieContext);

export const MovieProvider = ({ children }) => {
  const [nowPlayingMovies, setNowPlayingMovies] = useState([]);
  const [upcomingMovies, setUpcomingMovies] = useState([]);
  const [loadingNowPlaying, setLoadingNowPlaying] = useState(true);
  const [loadingUpcoming, setLoadingUpcoming] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Now Playing Movies
  useEffect(() => {
    const fetchNowPlayingMovies = async () => {
      try {
        setLoadingNowPlaying(true);
        const data = await getNowPlayingMovies();
        setNowPlayingMovies(data.results);
        setLoadingNowPlaying(false);
      } catch (err) {
        setError('Failed to fetch now playing movies. Please try again later.');
        setLoadingNowPlaying(false);
      }
    };

    fetchNowPlayingMovies();
  }, []);

  // Fetch Upcoming Movies
  useEffect(() => {
    const fetchUpcomingMovies = async () => {
      try {
        setLoadingUpcoming(true);
        const data = await getUpcomingMovies();
        setUpcomingMovies(data.results);
        setLoadingUpcoming(false);
      } catch (err) {
        setError('Failed to fetch upcoming movies. Please try again later.');
        setLoadingUpcoming(false);
      }
    };

    fetchUpcomingMovies();
  }, []);

  return (
    <MovieContext.Provider
      value={{
        nowPlayingMovies,
        upcomingMovies,
        loadingNowPlaying,
        loadingUpcoming,
        error,
        getImageUrl,
      }}
    >
      {children}
    </MovieContext.Provider>
  );
};

export default MovieContext;